import { render, staticRenderFns } from "./YouKuPlayPage.vue?vue&type=template&id=62855fa1&scoped=true"
import script from "./YouKuPlayPage.vue?vue&type=script&lang=js"
export * from "./YouKuPlayPage.vue?vue&type=script&lang=js"
import style0 from "./YouKuPlayPage.vue?vue&type=style&index=0&id=62855fa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62855fa1",
  null
  
)

export default component.exports